import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import ModalTabs from "app/components/Modal/ModalTabs";
import ArrowForward from "@material-ui/icons/ArrowForward";
import { Grid, Avatar, Typography } from "@material-ui/core";

import {
  getGroupFromState,
  getQualificationByCardIdFromState,
} from "features/planner/planner.selectors";

import { EMPTY_MAP } from "app/app.constants";
import { CardMapper } from "features/planner/planner.mappers";
import { getInitials, invokeIfFunction } from "utils/app.util";
import { CREATE_CARD_MOVE_FORM } from "features/planner/planner.constants";
import GroupFlagTypeBtn from "features/planner/components/Group/GroupFlagTypeBtn";
import { getEmployeeCardFromState } from "features/planner/employee/employee.selectors";
import EmployeeEarliestNextDeploymentWarning from "features/planner/employee/components/EmployeeEarliestNextDeploymentWarning";

const renderDefaultIcon = () => (
  <>
    <ArrowForward color="action" />
    <ArrowForward color="action" />
    <ArrowForward color="action" />
  </>
);

const CreateCardMoveTopContent = ({
  classes,
  renderIcon,
  targetGroup,
  employeeCard,
}) => {
  return (
    <>
      <ModalTabs>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={4} container className={classes.employeeContainer}>
            <Grid container spacing={2} wrap="nowrap" alignItems="center">
              <Grid item>
                <Avatar
                  classes={{
                    colorDefault: classes.avatarColorDefault,
                  }}
                >
                  {getInitials(employeeCard.get("name"))}
                </Avatar>
              </Grid>
              <Grid item zeroMinWidth>
                <Typography noWrap color="inherit">
                  {employeeCard.get("name")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid container item xs={2} justifyContent="center">
            {invokeIfFunction(renderIcon)}
          </Grid>
          <Grid item xs={4} container className={classes.locationContainer}>
            <Grid container spacing={2} wrap="nowrap" alignItems="center">
              <Grid item>
                <GroupFlagTypeBtn disabled group={targetGroup} />
              </Grid>
              <Grid item zeroMinWidth>
                <Typography color="secondary" noWrap>
                  {targetGroup.get("name")}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ModalTabs>
      {employeeCard && (
        <EmployeeEarliestNextDeploymentWarning
          employee={employeeCard.get("employee")}
        />
      )}
    </>
  );
};

const styles = theme => ({
  avatarColorDefault: {
    fontWeight: 500,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  },
  employeeContainer: {
    padding: theme.spacing(1),
    color: ({ qualification }) =>
      qualification
        ? theme.palette.getContrastText(qualification.get("backColor"))
        : theme.palette.getContrastText(theme.altus.background.header),
    background: ({ qualification }) =>
      qualification
        ? qualification.get("backColor")
        : theme.altus.background.header,
  },
  locationContainer: {
    padding: theme.spacing(1),
    background: theme.altus.background.header,
  },
});

CreateCardMoveTopContent.defaultProps = {
  targetGroup: EMPTY_MAP,
  renderIcon: renderDefaultIcon,
  employeeCard: CardMapper.initial(),
};

export default compose(
  connect((state, { formValueSelector }) => {
    const targetGroupId = formValueSelector(
      state,
      CREATE_CARD_MOVE_FORM.TARGET_GROUP_ID,
    );

    const cardId = formValueSelector(state, CREATE_CARD_MOVE_FORM.CARD);

    return {
      targetGroup: targetGroupId
        ? getGroupFromState(state, targetGroupId)
        : undefined,
      employeeCard: cardId
        ? getEmployeeCardFromState(state, cardId)
        : undefined,
      qualification: cardId
        ? getQualificationByCardIdFromState(state, cardId)
        : cardId,
    };
  }),
  withStyles(styles),
)(CreateCardMoveTopContent);
